import { Modal } from "react-bootstrap";
import { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import { MaterialReactTable } from "material-react-table";
import * as Comp from "../../../common/CommonComponents";
import * as common from "../../../common/common";

const TicketAttachmentModal = (props) => {
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);

  const [selectedData, setSelectedData] = useState([]);

  const data = props.ticketAttachment;

  function getSelectedData(dataSelected) {
    let promise = common.c_getTableSelectedData(data, dataSelected);
    promise.then((result) => {
      // console.log(dataSelected);
      setSelectedData(result);
    });
  }

  // useEffect(() => {
  //   //do something when the row selection changes...
  //   console.info({ rowSelection });
  // }, [rowSelection]);

  const columns = [
    {
      accessorKey: "ATTACHMENT_NAME",
      header: "File",
    },
  ];

  const hideModal = () => {
    props.onHide();
  };

  //#region Download Ticket Attachment
  const onDownloadAttachmentHandler = () => {
    if (Object.keys(selectedData) === 0) {
      toast.error("Please select file to download.");
    } else {
      var attachmentId = [];
      for (const key in selectedData) {
        attachmentId.push(selectedData[key].ATTACHMENT_ID);
      }
      window.open(
        common.c_getApiUrl() +
          `api/ticket/ExportAttachment?_user=${userId}&_attachmentId=${attachmentId}`
      );
    }
  };

  //#endregion

  return (
    <>
      <Modal show={props.showHide} onHide={hideModal} centered>
        <Modal.Header style={{ textAlign: "center" }}>
          <div style={{ backgroundColor: "lightgrey", width: "100%" }}>
            <Modal.Title>UPLOADED FILE</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Comp.Table
            columns={columns}
            data={props.ticketAttachment}
            enableRowSelection={true}
            getSelectedData={getSelectedData}
            enableStickyHeader
          />
        </Modal.Body>
        <Modal.Footer>
          <div style={{ textAlign: "center", width: "100%" }}>
            <Comp.Button
              id="btnDownload"
              type="download"
              onClick={onDownloadAttachmentHandler}
            >
              Download
            </Comp.Button>

            <Comp.Button id="btnCancel" type="cancel" onClick={hideModal}>
              Cancel
            </Comp.Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TicketAttachmentModal;
